(() => {
  document.querySelectorAll('[data-tasha-collection]').forEach(section => {
    const form = section.querySelector('form');
    const grid = section.querySelector('.tasha-product-grid');
    const cards = Array.from(grid.children);
    const update = () => {
      const values = new FormData(form);
      const price = values.get('max_price');
      const colour = values.get('colour');
      const available = values.get('availability');
      const sort = values.get('sort');
      let count = 0;
      cards.forEach(card => {
        card.hidden = Boolean((price !== '' && Number(card.dataset.price) > Number(price) * 100) || (colour && !card.dataset.colours.includes(colour)) || (available && card.dataset.available !== available));
        if (!card.hidden) count++;
      });
      const ordered = [...cards];
      if (sort === 'ascending' || sort === 'descending') ordered.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (sort === 'ascending' ? 1 : -1));
      ordered.forEach(card => grid.append(card));
      const status = section.querySelector('.tasha-filter-count');
      status.textContent = status.dataset.countTemplate.replace('[count]', count);
      section.querySelector('.tasha-filter-empty').hidden = count !== 0;
    };
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('reset', () => requestAnimationFrame(update));
    update();
  });
})();

(() => {
  const showReviews = () => {
    if (['#tab_pr_reivew', '#judgeme_product_reviews', '#tasha-product-reviews'].includes(location.hash)) {
      document.querySelector('#tasha-product-reviews')?.scrollIntoView({block:'start',behavior:'auto'});
    }
  };
  addEventListener('hashchange', showReviews);
  addEventListener('load', showReviews, {once:true});
  showReviews();
})();

(() => {
  if (!document.body.classList.contains('tasha-native-home')) return;
  const locate = () => {
    const carousel = document.querySelector('.jdgm-carousel-wrapper');
    if (!carousel) return false;
    carousel.id = 'tasha-customer-reviews';
    if (location.hash === '#tasha-customer-reviews') carousel.scrollIntoView({block: 'start', behavior: 'auto'});
    return true;
  };
  if (!locate()) {
    const observer = new MutationObserver(() => { if (locate()) observer.disconnect(); });
    observer.observe(document.body, {childList: true, subtree: true});
  }
})();

